import React from "react";
import './GameResults.scss';
import {useTranslation} from "react-i18next";

function GameResults({results}) {
  const {t} = useTranslation();

  return results ? <div className="all-results">
    <div className="latest-results results-box">
      <h3 className="results-title">{t('last 5').toUpperCase()}</h3>
      <div className="latest-results-numbers">
        {results['latest_results'] ? results['latest_results'].map((data, i) => {
          return <span className={data['color'].toLowerCase()} key={i}>{data['number']}</span>
        }) : null}
      </div>

      <div className="latest-round-numbers results-light">
        {results['latest_results'] ? results['latest_results'].map((data, i) => <span
          key={i}>{'# ' + data['round']}</span>) : null}
      </div>
    </div>

    <div className="latest-draws results-box">
      <h3 className="results-title">{t('last 120').toUpperCase()}</h3>
      <h3 className="results-title">{t('colors').toUpperCase()}</h3>
      <div className="latest-draws-numbers">
        {results['latest_draws'] ? results['latest_draws'].map((data, i) => <span
          key={i}>{data['count']}</span>) : null}
      </div>
    </div>

    <div className="win-results">
      <div className="sector">
        <h3 className="results-title">{t('sector').toUpperCase()}</h3>
        <div className="sector-numbers">
          {
            results['sector'] ? results['sector'].map((data, i) => {
              return <div key={i}>
                <span>{data['name']}</span>
                <span>{data['count']}</span>
              </div>
            }) : null
          }
        </div>
      </div>

      <div className="dozens">
        <h3 className="results-title">{t('dozens').toUpperCase()}</h3>
        <div>
          {
            results['dozens'] ? results['dozens'].map((data, i) => <React.Fragment key={i}>
              <span>{data['name']}</span>
              <span>{data['count']}</span>
            </React.Fragment>) : null
          }
        </div>
      </div>

      <div className="even-odd">
        <h3 className="results-title">{t('even odd').toUpperCase()}</h3>
        <div>
          {
            results['even_odd'] ? results['even_odd'].map((data, i) => <React.Fragment key={i}>
              <span>{data['name']}</span>
              <span>{data['count']}</span>
            </React.Fragment>) : null
          }
        </div>
      </div>
    </div>
  </div> : null;
}

export default GameResults;